export default "__VITE_ASSET__FJb$6Gk0__"